import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Button, Fab, GlobalStyles, Grow, Stack, Tooltip, Zoom } from '@mui/material';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { use, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BannerCard, { bannerShadow, TYPE_ICONS } from '@/components/maintenance/BannerCard';
import { fillVariables, groupMaintenanceRows, TYPES, windowVariables } from '@/components/maintenance/helpers';
import { useNow } from '@/hooks/useNow';
import { LayoutContext } from '@/layout';
import GlobalContext from '@/layout/Providers/GlobalContext';
import { config } from '@/layout/theme';
import { useGetMaintenanceBanner } from '@/operations/queries/getMaintenanceBanner';
const readMinimised = (): string[] => {
  try {
    return JSON.parse(localStorage.getItem('minimisedMaintenance') ?? '[]');
  } catch {
    return [];
  }
};
export function MaintenanceBanner() {
  const $ = _c(92);
  const {
    t
  } = useTranslation();
  const {
    language,
    user
  } = use(GlobalContext) ?? {};
  const {
    isMobile,
    drawerOpen
  } = use(LayoutContext);
  const {
    data
  } = useGetMaintenanceBanner();
  const now = useNow(60000);
  const [minimised, setMinimised] = useState(readMinimised);
  const [bannerHeight, setBannerHeight] = useState(0);
  const userLanguage = language === "dk" ? "da" : language;
  let FabIcon;
  let T0;
  let T1;
  let T2;
  let expanded;
  let fabType;
  let label;
  let messageIds;
  let messages;
  let saveMinimised;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== bannerHeight || $[1] !== data?.ta_maintenance || $[2] !== drawerOpen || $[3] !== isMobile || $[4] !== minimised || $[5] !== now || $[6] !== t || $[7] !== user || $[8] !== userLanguage) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const rows = data?.ta_maintenance ?? [];
      let t9;
      if ($[28] !== now || $[29] !== userLanguage) {
        t9 = item => {
          const showing = item.languages.filter(l => l.displayStart.valueOf() <= now && l.displayEnd.valueOf() >= now);
          const row = showing.find(l_1 => l_1.language === userLanguage) ?? showing.find(_temp);
          if (!row) {
            return [];
          }
          return [{
            ids: item.ids,
            type: item.type,
            published: item.published,
            text: fillVariables(row.text, windowVariables(item))
          }];
        };
        $[28] = now;
        $[29] = userLanguage;
        $[30] = t9;
      } else {
        t9 = $[30];
      }
      messages = groupMaintenanceRows(rows).flatMap(t9);
      if (!user || !messages.length) {
        t8 = null;
        break bb0;
      }
      let t10;
      if ($[31] !== minimised) {
        t10 = ids => ids.some(id => minimised.includes(id));
        $[31] = minimised;
        $[32] = t10;
      } else {
        t10 = $[32];
      }
      const isMinimised = t10;
      let t11;
      if ($[33] !== isMinimised) {
        t11 = message => !isMinimised(message.ids);
        $[33] = isMinimised;
        $[34] = t11;
      } else {
        t11 = $[34];
      }
      const visible = messages.filter(t11);
      expanded = visible.length > 0;
      messageIds = messages.flatMap(_temp2);
      fabType = TYPES.findLast(type => messages.some(message_1 => message_1.type === type));
      FabIcon = TYPE_ICONS[fabType];
      const t12 = `styra.maintenance_type.${fabType}`;
      let t13;
      if ($[35] !== t || $[36] !== t12) {
        t13 = t(t12);
        $[35] = t;
        $[36] = t12;
        $[37] = t13;
      } else {
        t13 = $[37];
      }
      label = t13;
      saveMinimised = ids_0 => {
        const rowIds = rows.map(_temp3);
        const next = [...new Set(ids_0)].filter(id_0 => rowIds.includes(id_0));
        setMinimised(next);
        localStorage.setItem("minimisedMaintenance", JSON.stringify(next));
      };
      let t14;
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = node => {
          if (!node) {
            return;
          }
          const observer = new ResizeObserver(t15 => {
            const [entry] = t15;
            return setBannerHeight(entry.borderBoxSize[0].blockSize);
          });
          observer.observe(node);
          return () => observer.disconnect();
        };
        $[38] = t14;
      } else {
        t14 = $[38];
      }
      const measureBanner = t14;
      const t15 = `${(expanded ? bannerHeight : 56) + 24}px !important`;
      if ($[39] !== t15) {
        t7 = <GlobalStyles styles={{
          ".notistack-SnackbarContainer": {
            bottom: t15
          }
        }} />;
        $[39] = t15;
        $[40] = t7;
      } else {
        t7 = $[40];
      }
      T2 = Box;
      if ($[41] !== drawerOpen || $[42] !== isMobile) {
        t6 = theme => ({
          zIndex: theme.zIndex.drawer - 1,
          position: "fixed",
          bottom: 0,
          right: 0,
          left: isMobile || !drawerOpen ? 0 : `${config.drawerWidth}px`,
          p: 1,
          pointerEvents: "none",
          transition: theme.transitions.create("left")
        });
        $[41] = drawerOpen;
        $[42] = isMobile;
        $[43] = t6;
      } else {
        t6 = $[43];
      }
      T1 = Grow;
      t3 = expanded;
      if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
          transformOrigin: "bottom right"
        };
        $[44] = t4;
      } else {
        t4 = $[44];
      }
      t5 = true;
      T0 = Stack;
      t0 = measureBanner;
      if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          gap: 1,
          pointerEvents: "auto"
        };
        $[45] = t1;
      } else {
        t1 = $[45];
      }
      let t16;
      if ($[46] !== minimised || $[47] !== saveMinimised || $[48] !== t) {
        t16 = message_2 => <BannerCard key={message_2.ids[0]} type={message_2.type} text={message_2.text} unpublished={!message_2.published} action={<Button variant="contained" color={message_2.type} disableElevation={true} startIcon={<RemoveRoundedIcon />} onClick={() => saveMinimised([...minimised, ...message_2.ids])} sx={{
          flexShrink: 0,
          ml: "auto"
        }}>{t("styra.action.hide_item", {
            item: t("styra.item.message_one")
          })}</Button>} />;
        $[46] = minimised;
        $[47] = saveMinimised;
        $[48] = t;
        $[49] = t16;
      } else {
        t16 = $[49];
      }
      t2 = visible.map(t16);
    }
    $[0] = bannerHeight;
    $[1] = data?.ta_maintenance;
    $[2] = drawerOpen;
    $[3] = isMobile;
    $[4] = minimised;
    $[5] = now;
    $[6] = t;
    $[7] = user;
    $[8] = userLanguage;
    $[9] = FabIcon;
    $[10] = T0;
    $[11] = T1;
    $[12] = T2;
    $[13] = expanded;
    $[14] = fabType;
    $[15] = label;
    $[16] = messageIds;
    $[17] = messages;
    $[18] = saveMinimised;
    $[19] = t0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    FabIcon = $[9];
    T0 = $[10];
    T1 = $[11];
    T2 = $[12];
    expanded = $[13];
    fabType = $[14];
    label = $[15];
    messageIds = $[16];
    messages = $[17];
    saveMinimised = $[18];
    t0 = $[19];
    t1 = $[20];
    t2 = $[21];
    t3 = $[22];
    t4 = $[23];
    t5 = $[24];
    t6 = $[25];
    t7 = $[26];
    t8 = $[27];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[50] !== T0 || $[51] !== t0 || $[52] !== t1 || $[53] !== t2) {
    t9 = <T0 ref={t0} sx={t1}>{t2}</T0>;
    $[50] = T0;
    $[51] = t0;
    $[52] = t1;
    $[53] = t2;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== T1 || $[56] !== t3 || $[57] !== t4 || $[58] !== t5 || $[59] !== t9) {
    t10 = <T1 in={t3} style={t4} unmountOnExit={t5}>{t9}</T1>;
    $[55] = T1;
    $[56] = t3;
    $[57] = t4;
    $[58] = t5;
    $[59] = t9;
    $[60] = t10;
  } else {
    t10 = $[60];
  }
  let t11;
  if ($[61] !== T2 || $[62] !== t10 || $[63] !== t6) {
    t11 = <T2 sx={t6}>{t10}</T2>;
    $[61] = T2;
    $[62] = t10;
    $[63] = t6;
    $[64] = t11;
  } else {
    t11 = $[64];
  }
  const t12 = !expanded;
  const t13 = messages.length < 2;
  let t14;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      position: "fixed",
      bottom: "16px",
      right: "16px",
      "& .MuiBadge-badge": {
        zIndex: _temp4
      }
    };
    $[65] = t14;
  } else {
    t14 = $[65];
  }
  let t15;
  if ($[66] !== messageIds || $[67] !== minimised || $[68] !== saveMinimised) {
    t15 = () => saveMinimised(minimised.filter(id_1 => !messageIds.includes(id_1)));
    $[66] = messageIds;
    $[67] = minimised;
    $[68] = saveMinimised;
    $[69] = t15;
  } else {
    t15 = $[69];
  }
  let t16;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      "&, &:active": {
        boxShadow: bannerShadow
      }
    };
    $[70] = t16;
  } else {
    t16 = $[70];
  }
  let t17;
  if ($[71] !== FabIcon) {
    t17 = <FabIcon />;
    $[71] = FabIcon;
    $[72] = t17;
  } else {
    t17 = $[72];
  }
  let t18;
  if ($[73] !== fabType || $[74] !== label || $[75] !== t15 || $[76] !== t17) {
    t18 = <Fab color={fabType} aria-label={label} onClick={t15} sx={t16}>{t17}</Fab>;
    $[73] = fabType;
    $[74] = label;
    $[75] = t15;
    $[76] = t17;
    $[77] = t18;
  } else {
    t18 = $[77];
  }
  let t19;
  if ($[78] !== label || $[79] !== t18) {
    t19 = <Tooltip title={label} placement="left">{t18}</Tooltip>;
    $[78] = label;
    $[79] = t18;
    $[80] = t19;
  } else {
    t19 = $[80];
  }
  let t20;
  if ($[81] !== messages.length || $[82] !== t13 || $[83] !== t19) {
    t20 = <Badge badgeContent={messages.length} invisible={t13} color="error" overlap="circular" sx={t14}>{t19}</Badge>;
    $[81] = messages.length;
    $[82] = t13;
    $[83] = t19;
    $[84] = t20;
  } else {
    t20 = $[84];
  }
  let t21;
  if ($[85] !== t12 || $[86] !== t20) {
    t21 = <Zoom in={t12} unmountOnExit={true}>{t20}</Zoom>;
    $[85] = t12;
    $[86] = t20;
    $[87] = t21;
  } else {
    t21 = $[87];
  }
  let t22;
  if ($[88] !== t11 || $[89] !== t21 || $[90] !== t7) {
    t22 = <>{t7}{t11}{t21}</>;
    $[88] = t11;
    $[89] = t21;
    $[90] = t7;
    $[91] = t22;
  } else {
    t22 = $[91];
  }
  return t22;
}
function _temp4(theme_0) {
  return theme_0.zIndex.speedDial + 1;
}
function _temp3(row_0) {
  return row_0.id;
}
function _temp2(message_0) {
  return message_0.ids;
}
function _temp(l_0) {
  return l_0.language === "en";
}